import { faCircleInfo } from "@fortawesome/pro-light-svg-icons/faCircleInfo";
import { faTimes } from "@fortawesome/pro-light-svg-icons/faTimes";

export default [
	faTimes, faCircleInfo
];
